<template>
  <div class="notice-info" v-show="publishValue">
    <img src="../../../assets/img-v2/ic_home_notice.png" class="icon" />
    <div
      class="text"
      :class="{ expand: isExpand }"
      @click="onGoRedirectUrl"
    >
      {{ publishValue }}
    </div>
    <img
      v-if="showMore"
      src="../../../assets/img-v2/ic_notice_arrow.png"
      class="img-more"
      :class="{ 'img-more-expand': isExpand }"
      @click="onToggle"
    />
    <!-- 计算单个字大小 -->
    <div id="font" class="size">测</div>
  </div>
</template>

<script>
import { isMiniprogram } from "@/utils";
import { MpUtil } from "@/utils/MpUtil";

export default {
  name: "NoticeInfo",
  props: {
    currentArea: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      showMore: false,
      isExpand: false,
    };
  },
  computed: {
    publishValue() {
      const { publishValue } = this.currentArea || {};
      return publishValue ? publishValue.trim() : "";
    },
    redirectUrl() {
      const { redirectUrl } = this.currentArea || {};
      return redirectUrl || "";
    },
  },
  watch: {
    publishValue: {
      immediate: true,
      handler(str) {
        if (str) {
          this.isExpand = false;
          this.showMore = false;
          setTimeout(() => {
            try {
              const noticeWidth = this.getFontWidth() * str.length + 80;
              const screenWidth = window.innerWidth;
              console.log("noticeWidth", noticeWidth, screenWidth);
              if (noticeWidth - screenWidth > 0) {
                this.showMore = true;
                this.isExpand = false;
              } else {
                this.showMore = false;
                this.isExpand = false;
              }
            } catch (error) {
              console.error("error", error);
            }
          }, 100);
        }
      },
    },
  },
  methods: {
    getFontWidth() {
      const font = document.getElementById("font");
      const { offsetWidth } = font || {};
      return offsetWidth || 15
    },
    onToggle() {
      this.isExpand = !this.isExpand;
    },
    onGoRedirectUrl() {
      if (this.redirectUrl) {
        if (isMiniprogram()) {
          MpUtil.navigateTo(
            MpUtil.getUrl("web", {
              h5Url: encodeURIComponent(this.redirectUrl),
            })
          );
        } else {
          window.open(this.redirectUrl);
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.notice-info {
  display: flex;
  align-items: flex-start;
  padding: 8px 18px;
  background: #cce5ff;
  border-radius: 8px;

  .icon {
    width: 16px;
    height: 16px;
    margin-right: 8px;
    margin-top: 2px;
  }

  .text {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #006efa;
    line-height: 20px;
    text-align: left;
    font-style: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .size {
    position: absolute;
    top: -1000px;
    left: -1000px;
    opacity: 0;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #006efa;
    line-height: 20px;
    text-align: left;
    font-style: normal;
  }

  .expand {
    overflow: visible!important;
    text-overflow: unset!important;
    white-space: normal!important;
  }

  .img-more {
    width: 26px;
    height: 16px;
    min-width: 26px;
    padding: 0 5px;
    margin-top: 2px;
  }
  .img-more-expand {
    transform: rotate(180deg);
  }
}
</style>
